import React, { useRef, Children, cloneElement } from 'react';
import { TransitionGroup } from 'react-transition-group';

let keyCounter = 0;

const createKeysList = (prevList, currentList) => {
    let prevIndex = 0;
    let currentIndex = 0;
    const nextList = [];
    while (prevIndex < prevList.length && currentIndex < currentList.length) {
        const prev = prevList[prevIndex];
        const current = currentList[currentIndex];
        if (prev[0] === current) {
            nextList.push(prev);
            currentIndex += 1;
            prevIndex += 1;
        } else {
            nextList.push([currentList[currentIndex], keyCounter]);
            keyCounter += 1;
            currentIndex += 1;
        }
    }
    for (let i = currentIndex; i < currentList.length; i++) {
        nextList.push([currentList[i], keyCounter]);
        keyCounter += 1;
    }
    return nextList;
};

export default (props) => {
    const { children } = props;
    const prevKeys = useRef([]);
    const childrenArray = Children.toArray(children);
    const keysArray = childrenArray.map(child => child.key);
    const nextKeys = createKeysList(prevKeys.current, keysArray);
    prevKeys.current = nextKeys;

    return <TransitionGroup component={null}>
        {nextKeys.map(([, key], index) => cloneElement(childrenArray[index], { key }))}
    </TransitionGroup>;
};
